module.exports = __webpack_public_path__ + "static/media/03.56934e0e.jpg";